// src/analytics/analyticsConfig.ts
import * as amplitude from '@amplitude/analytics-browser';
import { getAppConfig } from '../config/appConfig';

/**
 * Initializes Amplitude analytics with the correct configuration.
 * Uses EU server zone, cookie-based identity storage, and disabled autocapture.
 * Fails gracefully if configuration is missing or initialization fails.
 */
export function initializeAmplitude(): void {
  try {
    const config = getAppConfig();
    if (!config.amplitudeApiKey) {
      console.warn('Amplitude API key not configured, analytics disabled');
      return;
    }

    amplitude.init(config.amplitudeApiKey, undefined, {
      serverZone: 'EU',
      identityStorage: 'cookie',
      autocapture: false,
    });
  } catch (error) {
    console.error('Failed to initialize Amplitude:', error);
  }
}
